module.exports = __webpack_public_path__ + "img/france-tuberculosis-male.12c4265f.png";